module.exports = __webpack_public_path__ + "static/img/bg_auth.0d3e5209.jpg";